export default __webpack_public_path__ + "static/media/4.69b485b6.png";